import React, { useState } from 'react';
import {
    Modal,
    ModalHeader,
    ModalBody,
    Row,
    Col
} from 'reactstrap';
import { dateFormate } from 'utils/columns';

const FallourReasonsModal = ({ isOpen, toggle, row }) => {


    return (
        <div>
            <Modal isOpen={isOpen} toggle={toggle} size="xl">
                <ModalHeader toggle={toggle}>Claim Fallout Reasons</ModalHeader>
                <ModalBody style={{ minHeight: 200 }}>
                    <h5 className='f-15 text-primary font-weight-700'>
                        Claim Details
                    </h5>
                    <Row className='mt-3'>
                        <Col md="3">
                            <p className="m-0 f-14 ">Claim ID : &nbsp;&nbsp;
                                <span className="m-0 f-14 font-weight-500 mt-1">{row?.claimID}</span></p>
                        </Col>
                        <Col md="3">
                            <p className="m-0 f-14 ">Rx Number : &nbsp;&nbsp;
                                <span className="m-0 f-14 font-weight-500 mt-1">{row?.rxNumber}</span></p>
                        </Col>
                        <Col md="3">
                            <p className="m-0 f-14 ">Fill # : &nbsp;&nbsp;
                                <span className="m-0 f-14 font-weight-500 mt-1">{row?.refillNumber}</span></p>
                        </Col>
                        <Col md="3">
                            <p className="m-0 f-14 ">Date Rx Written: &nbsp;&nbsp;
                                <span className="m-0 f-14 font-weight-500 mt-1">{dateFormate(row?.dateRXWritten)}</span></p>
                        </Col>
                    </Row>
                    <Row className='mt-3'>
                        <Col md="3">
                            <p className="m-0 f-14 ">Date of Service : &nbsp;&nbsp;
                                <span className="m-0 f-14 font-weight-500 mt-1">{dateFormate(row?.dateOfService)}</span></p>
                        </Col>
                        <Col md="3">
                            <p className="m-0 f-14 ">First Name : &nbsp;&nbsp;
                                <span className="m-0 f-14 font-weight-500 mt-1">{row?.patientFirstName}</span></p>
                        </Col>
                        <Col md="3">
                            <p className="m-0 f-14 ">Last Name : &nbsp;&nbsp;
                                <span className="m-0 f-14 font-weight-500 mt-1">{row?.patientLastName}</span></p>
                        </Col>
                        <Col md="3">
                            <p className="m-0 f-14 ">DOB: &nbsp;&nbsp;
                                <span className="m-0 f-14 font-weight-500 mt-1">{dateFormate(row?.patientDOB)}</span></p>
                        </Col>
                    </Row>
                    <Row className='mt-3'>
                        <Col md="8">
                            <p className="m-0 f-14 ">Prescriber Name : &nbsp;&nbsp;
                                <span className="m-0 f-14 font-weight-500 mt-1">{row?.prescriberName}</span></p>
                        </Col>
                    </Row>
                    <hr />
                    <div className="table-card rounded-table">
                        <table className="theme-table table-responsive border-0 w-100">
                            <thead>
                                <tr>
                                    <th>Fallout Reasons</th>
                                    <th>Description</th>
                                    <th> </th>
                                </tr>
                            </thead>
                            <tbody>
                                {row != undefined && row.reasons != undefined && row.reasons.map((item) => {
                                    return (
                                        <tr key={item.id}>
                                            <td>
                                                {item.ruleDescription}
                                            </td>
                                            <td>
                                                {item.reasonDescription}
                                            </td>
                                            <td>
                                            </td>

                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default FallourReasonsModal;